import { useState, useEffect } from 'react';
import { useInvestmentsState, useWeb3State } from 'state';
import { accordionActionsClasses, Chip } from '@mui/material';
import { weiToEth, formatDecimal } from 'helpers/numbers';

export default function UnClaimedRewards({ tokenAddress, nonce }) {
  const { fetchUnClaimedRewards, account } = useWeb3State();
  const { canIssueResponse, setcanIssueResponse } = useInvestmentsState();

  useEffect(() => {
    const fetchdata = async () => {
      const response = await fetchUnClaimedRewards(tokenAddress, account);
      console.log('response', response);
      setcanIssueResponse(response);
    };
    fetchdata();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonce]);

  return (
    <Chip
      label={`${formatDecimal(parseFloat(weiToEth(canIssueResponse)))} XDC `}
      color={canIssueResponse > 0 ? 'success' : 'error'}
    />
  );
}
